(function ($) {
    $(function () {
        $('.downloads').each(function (i, el) {
            var $downloads = $(el).find('.download');
            $downloads.find('.download-content').slideUp(0);
            $downloads.find('.download-trigger').on('click', function (e) {
                var $download = $(e.target).closest('.download');
                if ($download.hasClass('active')) {
                    $download.removeClass('active');
                    $download.find('.download-content').stop().slideUp(300);
                }
                else {
                    // $('.download.active').find('.download-content').stop().slideUp(300)
                    // $('.download.active').removeClass('active')
                    $download.addClass('active');
                    $download.find('.download-content').stop().slideDown(300);
                }
            });
        });
    });
})(jQuery);
